export default "__VITE_ASSET__17f24033__"